"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HORIZONTAL_PANEL_TRANSITION_DURATION = void 0;
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var theme_1 = require("../../utils/theme");
var helper_1 = require("../../utils/helper");
var keepDom_1 = require("../../utils/keepDom");
var docs_user_agent_1 = tslib_1.__importDefault(require("@tencent/docs-user-agent"));
exports.HORIZONTAL_PANEL_TRANSITION_DURATION = 300;
var HorizontalPanel = (function (_super) {
    tslib_1.__extends(HorizontalPanel, _super);
    function HorizontalPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            noAnimation: false,
        };
        _this.handleResize = function () {
            var handler = function () {
                _this.setState({ noAnimation: true });
                setTimeout(function () {
                    _this.setState({ noAnimation: false });
                }, exports.HORIZONTAL_PANEL_TRANSITION_DURATION);
            };
            if (docs_user_agent_1.default.isIOS) {
                setTimeout(handler, 0);
            }
            else {
                handler();
            }
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, children = _b.children, visible = _b.visible, destroyOnClose = _b.destroyOnClose, okText = _b.okText, onOk = _b.onOk, title = _b.title, headerStyle = _b.headerStyle, contentStyle = _b.contentStyle, zIndex = _b.zIndex, cancelText = _b.cancelText, onCancel = _b.onCancel, header = _b.header, headerClassName = _b.headerClassName, contentClassName = _b.contentClassName;
            var noAnimation = _this.state.noAnimation;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-hidden"] = !visible,
                _a[prefixCls + "-no-animation"] = noAnimation,
                _a));
            var headerClasses = classNames(prefixCls + "-header", headerClassName);
            var titleClassName = classNames(prefixCls + "-header-title");
            if (destroyOnClose && !keepDom_1.decideKeepDom.call(_this, exports.HORIZONTAL_PANEL_TRANSITION_DURATION, visible)) {
                return null;
            }
            return react_dom_1.default.createPortal(h("div", { className: classes, style: tslib_1.__assign(tslib_1.__assign({ zIndex: zIndex }, style), _this.getRenderSize()) },
                h("div", { className: headerClasses, style: headerStyle }, header ?
                    header
                    : h(React.Fragment, null,
                        cancelText && h("span", { className: classNames(prefixCls + "-header-cancel"), onClick: onCancel }, cancelText),
                        h("span", { className: titleClassName }, title),
                        okText && h("span", { className: classNames(prefixCls + "-header-ok"), onClick: onOk }, okText))),
                h("div", { className: classNames(prefixCls + "-content", contentClassName), style: contentStyle }, children)), document.body);
        };
        return _this;
    }
    HorizontalPanel.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.handleResize);
    };
    HorizontalPanel.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleResize);
    };
    HorizontalPanel.prototype.getRenderSize = function () {
        var innerHeight = window.innerHeight, innerWidth = window.innerWidth;
        var width = Math.max(innerWidth, innerHeight);
        var height = Math.min(innerWidth, innerHeight);
        return { width: width, height: height };
    };
    HorizontalPanel.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return HorizontalPanel;
}(React.Component));
exports.default = HorizontalPanel;
HorizontalPanel.defaultProps = {
    prefixCls: 'dui-m-horizontalpanel',
    title: '标题',
    okText: '完成',
    cancelText: '取消',
    onOk: helper_1.emptyFn,
    onCancel: helper_1.emptyFn,
    destroyOnClose: true,
};
HorizontalPanel.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    destroyOnClose: PropTypes.bool,
    okText: PropTypes.node,
    cancelText: PropTypes.node,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    title: PropTypes.node,
    visible: PropTypes.bool,
    headerStyle: PropTypes.object,
    contentStyle: PropTypes.object,
    zIndex: PropTypes.number,
    header: PropTypes.node,
    headerClassName: PropTypes.string,
    contentClassName: PropTypes.string,
};
